import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';

class ScrollItem__BlockSliderHorizontalScroll extends VScroll_Item {
    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.onShow = () => {};
        this.onHide = () => {};
        this.onMove = () => {};
    }

    resize(__w, __h) {
        super.resize(__w, __h);
    }

    dispose() {
        super.dispose();
    }
}

Scroll._registerClass('BlockSliderHorizontalScroll', ScrollItem__BlockSliderHorizontalScroll);

export default ScrollItem__BlockSliderHorizontalScroll;
